import { get } from '@/utils/Api'
import UrlStore from '@/utils/UrlStore'
import { staleTimezones, timezoneDisplayName } from '@/utils/timezones'

export const TIMEZONES_LOAD = 'TIMEZONES_LOAD'

let timezonesPromise = null

export default {
  namespaced: true,
  state: {
    timezonesLoaded: false,
    timezonesList: []
  },
  getters: {
    timezones(state) {
      return state.timezonesList
    },
    getTimezoneLabel: (state) => (id) => {
      let tz = state.timezonesList.find((t) => t.id === id)
      return tz ? timezoneDisplayName(tz) : id
    },
    // zones of this workspace's buildings that the viewer's browser reads with outdated rules
    staleBuildingTimezones(state, getters, rootState, rootGetters) {
      if (!state.timezonesLoaded) return []
      const zones = (rootGetters['building/buildings'] || []).map((building) => building && building.timezone)
      return staleTimezones(state.timezonesList, zones)
    }
  },
  mutations: {
    [TIMEZONES_LOAD](state, list) {
      state.timezonesList = list
      state.timezonesLoaded = true
    }
  },
  actions: {
    timezonesLoad({ commit, state }) {
      if (state.timezonesLoaded) {
        return Promise.resolve(state.timezonesList)
      }
      if (!timezonesPromise) {
        timezonesPromise = get(`/${UrlStore.TIMEZONES}`).then((r) => {
          commit(TIMEZONES_LOAD, r.data)
          return r.data
        })
      }
      return timezonesPromise
    }
  }
}
